import React from "react";
import styled from "styled-components";
import { Container } from "../Section";
import { GatsbyImage } from "gatsby-plugin-image";
import { ProductSku } from "../ProductStyle";
import { RoofIcon, GaugeIcon, ManufacurerIcon, MapPointerIcon, TickIcon, PhoneIcon } from "../Icons";
import AddToCart from "../AddToCart";
import AddToComparison from "../AddToComparison";
import PrimaryButton from "../Button/PrimaryButton";

const ProductGridDtl = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  margin: 0 -15px;
  @media (min-width: 1200px) {
    margin: 0 -20px;
  }
`;
const ProducLeftDtl = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
    .product-name {
      display: none;
    }
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (min-width: 1600px) {
    flex: 0 0 58.333333%;
    max-width: 58.333333%;
  }
`;
const ProducRightDtl = styled.div`
  position: relative;
  width: 100%;
  padding: 0 15px;
  @media (min-width: 992px) {
    flex: 0 0 50%;
    max-width: 50%;
  }
  @media (min-width: 1200px) {
    padding: 0 20px;
  }
  @media (max-width: 991.98px) {
    .product-name {
      display: none;
    }
  }
  @media (min-width: 1600px) {
    flex: 0 0 41.666667%;
    max-width: 41.666667%;
  }
`;

const ProductCard = styled.div`
  position: relative;
  margin-bottom:15px;
  @media (min-width: 1200px) {
    margin-bottom:20px;
  }
  @media (min-width: 1600px) {
    margin-bottom:30px;
  }
`;
const ProductBody = styled.div`
  position: relative;
`;
const ProductFigure = styled.div`
  position: relative;
  overflow: hidden;
  .gatsby-image-wrapper {
    border-radius: 10px;
  }
`;
const ProductName = styled.h1`
  text-transform: inherit;
  margin-bottom: 10px;
  font-size: 24px;
  line-height: 34px;
  @media (min-width: 1200px) {
    font-size: 26px;
    line-height: 36px;
  }
  @media (min-width: 1600px) {
    font-size: 28px;
    line-height: 38px;
  }
`;
const ProductNameMobile = styled.div`
  font-family: "Oxanium", serif;
  font-weight: 700;
  margin-bottom: 10px;
  text-transform: inherit;
  margin-bottom: 10px;
  font-size: 24px;
  line-height: 34px;
`;
const ProductCta = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 0 -5px 15px -5px;
  a,
  button {
    width: 100%;
    .btn {
      width: 100%;
      .icon{
        @media (min-width: 1600px) {
          padding: 9px 25px !important;
        }
        svg{width:24px;}
      }
    }
  }
  @media (min-width: 1200px) {
    margin: 0 -10px 20px -10px;
  }
  @media (min-width: 1600px) {
    margin: 0 -10px 30px -10px;
  }
`;
const ProductItemCta = styled.div`
  position: relative;
  width: 100%;
  padding: 0 5px;
  @media (min-width: 576px) {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  @media (min-width: 1200px) {
    padding: 0 10px;
  }
  &.product-item-cta {
    + .product-item-cta {
      margin-top: 15px;
      @media (min-width: 576px) {
        margin-top: 0;
      }
    }
  }
`;
const ListInfo = styled.div`
  margin-bottom: 30px;
  text-align: left;
`;
const ListItemInfo = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: self-start;
  color: #373636;
  font-size: 14px;
  line-height: 20px;
  @media (min-width: 1200px) {
    font-size: 16px;
    line-height: 28px;
  }
  a {
    display: inline-block;
    color: #373636;
    position: relative;
    &:hover {
      color: #e9242a;
    }
  }
  + .list-item {
    margin-top: 8px;
    @media (min-width: 1200px) {
      margin-top: 10px;
    }
  }
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 20px;
    @media (min-width: 1200px) {
      height: 28px;
    }
    > svg {
      fill: #e9242a;
      width: 20px;
    }
    + .text {
      margin-left: 15px;
    }
  }
  .text {
    b {
      font-weight: 600;
    }
  }
`;

const PriceBox = styled.div`
  margin-bottom: 20px;
  border-radius: 10px;
  overflow: hidden;

  background-image: repeating-linear-gradient(
      0deg,
      #eef0fd,
      #eef0fd 10px,
      transparent 10px,
      transparent 20px,
      #eef0fd 20px
    ),
    repeating-linear-gradient(
      90deg,
      #eef0fd,
      #eef0fd 10px,
      transparent 10px,
      transparent 20px,
      #eef0fd 20px
    ),
    repeating-linear-gradient(
      180deg,
      #eef0fd,
      #eef0fd 10px,
      transparent 10px,
      transparent 20px,
      #eef0fd 20px
    ),
    repeating-linear-gradient(
      270deg,
      #eef0fd,
      #eef0fd 10px,
      transparent 10px,
      transparent 20px,
      #eef0fd 20px
    );
  background-size: 3px 100%, 100% 3px, 3px 100%, 100% 3px;
  background-position: 0 0, 0 0, 100% 0, 0 100%;
  background-repeat: no-repeat;
`;
const PriceInnerBox = styled.div`
  position: relative;
  padding: 20px;
  &:before {
    position: absolute;
    width: calc(100% - 4px);
    height: calc(100% - 4px);
    top: 2px;
    left: 2px;
    content: "";
    background-color: #eef0fd;
  }
`;
const PriceInfo = styled.div`
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  border-bottom: 1px solid #fff;
  align-items: center;
  margin-bottom: 15px;
  padding-bottom: 10px;
  @media (min-width: 576px) {
    margin-bottom: 20px;
    padding-bottom: 15px;
  }
`;
const ProductPrice = styled.div`
  position: relative;
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: 576px) {
    align-items: center;
    flex-wrap: nowrap;
    flex-direction: row;
  }
  small {
    font-weight: 600;
    color: #373636;
    font-size: 14px;
    @media (min-width: 1200px) {
      font-size: 16px;
    }
    @media (min-width: 1600px) {
      font-size: 18px;
    }
    + strong {
      @media (min-width: 576px) {
        margin-left: 10px;
      }
    }
  }
  strong {
    font-weight: 700;
    color: #e9242a;
    font-size: 24px;
    line-height: 28px;
    @media (min-width: 768px) {
      font-size: 28px;
      line-height: 32px;
    }
    @media (min-width: 1200px) {
      font-size: 32px;
      line-height: 36px;
    }
  }
`;
const RtoInfo = styled.div`
  position: relative;
  text-align: left;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin: 0 -15px;
  @media (min-width: 1200px) {
    margin: 0 -15px;
  }
`;
const RtoItemInfo = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  padding: 0 15px;

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    > svg {
      fill: #e9242a;
      width: 20px;
    }
    + .text {
      margin-left: 15px;
    }
  }
  .text {
    font-size: 14px;
    line-height: 24px;
    font-weight: 600;
    @media (min-width: 1200px) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;
const HelpText = styled.div`
  position: relative;
  font-weight: 500;
  color: #a0a2b2;
  font-size: 12px;
  line-height: 18px;
  margin-left: 10px;
  @media (min-width: 576px) {
    margin-left: 20px;
  }
`;
const ProductInfo = ({ productData }) => {
  return (
    <Container>
      <ProductGridDtl>
        <ProducLeftDtl>
          <ProductNameMobile className="product-name">
            {productData.title}
          </ProductNameMobile>
          <ProductCard className="card">
            <ProductSku className="sku-lg">
              SKU : {productData.skuNumber}
            </ProductSku>
            <ProductBody className="card-body">
              <ProductFigure className="card-figure">
                <GatsbyImage
                  image={productData.image.gatsbyImageData}
                  alt={productData.title}
                />
                <AddToComparison product={productData} />
              </ProductFigure>
            </ProductBody>
          </ProductCard>
        </ProducLeftDtl>
        <ProducRightDtl>
          <ProductName className="product-name">
            {productData.title}
          </ProductName>
          <PriceBox>
            <PriceInnerBox>
              <PriceInfo>
                <ProductPrice>
                  <small>Starting Price:</small>{" "}
                  <strong>
                    ${productData.price.toLocaleString("en-US")}*
                  </strong>
                </ProductPrice>
                <HelpText>
                  (Prices vary by state, location, & customization)
                </HelpText>
              </PriceInfo>
              <RtoInfo className="rto-info">
                {productData.rto && (
                  <RtoItemInfo className="rto-item">
                    <span className="icon">
                      <TickIcon />
                    </span>
                    <span className="text">RTO / Financing</span>
                  </RtoItemInfo>
                )}
                <RtoItemInfo className="rto-item">
                  <span className="icon">
                    <TickIcon />
                  </span>
                  <span className="text">
                    Delivery & Installation Included
                  </span>
                </RtoItemInfo>
              </RtoInfo>
            </PriceInnerBox>
          </PriceBox>

          <ListInfo className="list-info">
            <ListItemInfo className="list-item">
              <span className="icon">
                <MapPointerIcon />
              </span>
              <span className="text">
                Building Location:{" "}
                <b>
                  {" "}
                  {productData.city}, {productData.state}{" "}
                  {productData.zipcode}
                </b>
              </span>
            </ListItemInfo>
            <ListItemInfo className="list-item">
              <span className="icon">
                <GaugeIcon />
              </span>
              <span className="text">
                Gauge:{" "}
                <b>
                  {" "}
                  {productData["gaugeTubing"] || 0}-Gauge Tubing,{" "}
                  {productData["gaugePanels"] || 0}-Gauge Panels (Upgrade
                  Available)
                </b>
              </span>
            </ListItemInfo>
            <ListItemInfo className="list-item">
              <span className="icon">
                <ManufacurerIcon />
              </span>
              <span className="text">
                Manufacturer: <b> {productData["manufacturer"]}</b>
              </span>
            </ListItemInfo>
            <ListItemInfo className="list-item">
              <span className="icon">
                <RoofIcon />
              </span>
              <span className="text">
                Roof Style: <b> {productData["roofStyleType"]}</b>
              </span>
            </ListItemInfo>
            {/* <ListItemInfo className="list-item">
                <span className="icon">
                <HomeIcon />
                </span>
                <span className="text">
                Condition:<b> {productData["buildingCondition"]}</b>
                </span>
            </ListItemInfo> */}
          </ListInfo>

          <ProductCta>
            <ProductItemCta className="product-item-cta">
              <a href="tel:2085721441" aria-label="phone number"><PrimaryButton icon={<PhoneIcon />} text="(208) 572-1441" size="xl" /></a>
            </ProductItemCta>
            <ProductItemCta className="product-item-cta">
              <AddToCart product={productData} />
            </ProductItemCta>
          </ProductCta>
        </ProducRightDtl>
      </ProductGridDtl>
    </Container>
  )
}

export default ProductInfo
